import { render, staticRenderFns } from "./MigrationResult.vue?vue&type=template&id=71b10642&scoped=true"
import script from "./MigrationResult.vue?vue&type=script&lang=js"
export * from "./MigrationResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b10642",
  null
  
)

export default component.exports